import type { ReactNode } from "react";
import { HStack } from "../../layout/stack";
import { cn } from "../../lib/utils";
import { MessageWrapper } from "./shared";
import { ToolAvatar } from "./tool-avatar";
import type { BaseToolMessageProps } from "./types";

export function BaseToolMessage({
	text,
	icon,
	children,
	className,
	actions,
	isLoading = false,
	isDone = false,
	isCanceled = false,
}: BaseToolMessageProps & {
	className?: string;
	children?: ReactNode;
}): React.ReactElement {
	if (isDone && isLoading) {
		throw new Error("Cannot be done and loading at the same time");
	}

	return (
		<MessageWrapper
			className={cn(
				"border border-border-primary",
				"text-md text-text-body-inverted",
				"mx-auto w-full max-w-feed",
				className,
			)}
		>
			<HStack className="items-center gap-md">
				<ToolAvatar
					badgeClassName={className}
					icon={icon}
					isCanceled={isCanceled}
					isDone={isDone}
					isLoading={isLoading}
				/>
				<div className="w-full truncate opacity-0 transition-opacity duration-150 [&:not(:empty)]:opacity-100">
					{text}
				</div>
				<HStack className="gap-min">{actions}</HStack>
			</HStack>
			{children}
		</MessageWrapper>
	);
}
